import firebase from './firebase_config.js';
import 'firebase/auth';


export function setToken(cb){
  const user = firebase.auth().currentUser;
  if (user){
    user.getIdToken(true).then(function(idToken) {
      window.setIdToken(idToken);
      cb();
    }).catch(function(error) {
      console.log("User is not authenticated");
    });
  }
}

export function signInAnonymously(){
    firebase.auth().signInAnonymously().catch(function(error) {
        console.log("Failed to register user anonymously", error.message);
    });
}

export function signUpAnonymousUser(email, password){
    const credential = firebase.auth.EmailAuthProvider.credential(email, password);
    firebase.auth().currentUser.linkWithCredential(credential).then(function(usercred) {
      var user = usercred.user;
      console.log("Anonymous account successfully upgraded", user);
    }, function(error) {
      console.log("Error upgrading anonymous account", error);
    });
}
